











































































import { Component, Vue } from "vue-property-decorator";
import { clearFilter } from "@/utils/base";
import { PostLogin } from "@/request/common";
import Remember from "../components/remember.vue";
import { Md5 } from "ts-md5";
@Component({
  components: {
    Remember,
  },
})
export default class Login extends Vue {
  private type: any = "text";
  private ifRember: any = true;
  private visible: any = false;
  private window: any = window;
  private loginInfo: any = {
    用户名: "",
    密码: "",
  };

  private paws: any = [];
  private showPassword: any = false;
  private path: any = "";
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private get system() {
    return this.$store.state.system;
  }
  private goRegister() {
    this.$router.push("/access/register");
  }
  private changeEye(val: any) {
    this.showPassword = val;
    if (val) {
      this.type = "text";
    } else {
      this.type = "password";
    }
  }
  private pawInput(e: any) {
    if (this.loginInfo["密码"] && !this.showPassword) {
      this.type = "password";
    } else {
      this.type = "text";
    }
  }
  private focus() {
    if (localStorage.getItem("xunzhengpaws")) {
      this.paws = JSON.parse(localStorage.getItem("xunzhengpaws") || "");
    }
  }
  private update(e: any) {
    this.type = "password";
    this.loginInfo["用户名"] = e.name;
    this.loginInfo["密码"] = e.paw;
    this.visible = false;
  }
  private delPaw(e: any) {
    if (e.length == 0) {
      this.type = "text";
    }
    this.paws = JSON.parse(JSON.stringify(e));
  }
  /**
   * @description 登录
   */
  private login(): void {
    if (!this.loginInfo["用户名"]) {
      this.$message.warning("请输入用户名");
      return;
    }
    if (!this.loginInfo["密码"]) {
      this.$message.warning("请输入密码");
      return;
    }
    // 管理端需要拦截，只能admin登录
    if (this.system == "管理端" && this.loginInfo["用户名"] != "admin") {
      this.$message.warning("账号不存在");
      return;
    }

    const params: any = {
      username: this.loginInfo["用户名"],
      password: Md5.hashStr(this.loginInfo["密码"]),
    };
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    PostLogin(this, params, loading)
      .then((res: any) => {
        loading.close();
        const d = res.data;
        const token = d.access;
        const user = d;
        this.$store.commit("updateToken", token);
        this.$store.commit("updateUser", user);
        if (this.ifRember) {
          // 如果没有存过则储存，如果已经储存过则更新
          if (this.paws.length === 0) {
            this.paws.push({
              name: this.loginInfo["用户名"],
              paw: this.loginInfo["密码"],
            });
          } else {
            let ifRepeat: any = false;
            let i: any = "";
            this.paws.forEach((ele: any, index: any) => {
              if (ele.name == this.loginInfo["用户名"]) {
                i = index;
                ifRepeat = true;
              }
            });
            if (ifRepeat) {
              this.paws.splice(i, 1);
            }
            this.paws.push({
              name: this.loginInfo["用户名"],
              paw: this.loginInfo["密码"],
            });
          }
        }
        localStorage.setItem("xunzhengpaws", JSON.stringify(this.paws));
        this.goPage();
      })
      .catch(() => {
        loading.close();
      });
  }
  private goPage() {
    clearFilter();
    if (this.path) {
      this.$router.push(this.path);
      return;
    }
    // 直接打开登录页时 system 可能为空，默认按用户端跳转
    const system = this.system || "用户端";
    if (!this.system) {
      this.$store.commit("updateSystem", "用户端");
    }
    if (system == "用户端") {
      this.$router.push("/home/folder");
    } else if (system == "管理端") {
      this.$router.push("/main/manage/list");
    }
  }
  private mounted() {
    // 直接访问登录页时初始化端类型，避免登录后无法跳转
    if (!this.$store.state.system) {
      this.$store.commit("updateSystem", "用户端");
    }
    if (localStorage.getItem("xunzhengpaws")) {
      this.paws = JSON.parse(localStorage.getItem("xunzhengpaws") || "");
    }
    if (this.$route.query.path) {
      this.path = this.$route.query.path;
    }
  }
}
